<template>
  <div class="settings-wrapper" @click="closeWrapper" ref="settingsWrapper">
    <div :class="{'settings-box': true, closeAnimation}">

      <div class="top-row">
        <div class="title">Settings</div>
        <div class="close">
          <font-awesome-icon icon="times" class="icon" @click="close"/>
        </div>
      </div>

      <div class="loading-row" v-if="loading">
        <loader/>
      </div>

      <div class="bottom-row" v-if="!loading">
        
        <div class="option-row">
          <div class="switch-box">

            <label class="toggle-control" v-if="!loader.private">
              <input type="checkbox" v-model="getReversedPrivateValue" @click.prevent="changePrivateOption">
              <span class="control"></span>
            </label>

            <div class="lds-ring" v-if="loader.private"><div></div><div></div><div></div><div></div></div>

          </div>
          <div class="text-box"><span>Public dialogue</span></div>
        </div>

        <div class="option-row">
          <div class="switch-box">

            <label class="toggle-control" v-if="!loader.blockCopy">
              <input type="checkbox" v-model="getReversedBlockCopyValue" @click.prevent="changeCopyOption">
              <span class="control"></span>
            </label>

            <div class="lds-ring" v-if="loader.blockCopy"><div></div><div></div><div></div><div></div></div>

          </div>
          <div class="text-box"><span>Copyable dialogue</span></div>
        </div>

        <div class="option-row">
          <div class="switch-box">

            <label class="toggle-control" v-if="!loader.autoContinue">
              <input type="checkbox" v-model="getReversedAutoContinueValue" @click.prevent="changeAutoContinue">
              <span class="control"></span>
            </label>

            <div class="lds-ring" v-if="loader.autoContinue"><div></div><div></div><div></div><div></div></div>

          </div>
          <div class="text-box"><span>Continue button</span></div>
        </div>

        <div class="playmodes-row">
          <div class="switch-box">
            <div :class="{'play-mode-box': true, 'play-mode-active': settings.activePlayModes.play}" title="Play" @click="changeActivePlayModes('play')">
              <font-awesome-icon icon="play" class="play-icon"/>
            </div>
            <div :class="{'play-mode-box': true, 'play-mode-active': settings.activePlayModes.learn}" title="Learn" @click="changeActivePlayModes('learn')">
              <font-awesome-icon icon="book-open" class="learn-icon"/>
            </div>
            <div :class="{'play-mode-box': true, 'play-mode-active': settings.activePlayModes.record}" title="Record" @click="changeActivePlayModes('record')">
              <font-awesome-icon icon="microphone-alt" class="record-icon"/>
            </div>
          </div>
          <div class="text-box"><span>Display modes</span></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import alert from '@/lib/alert';
import swal from 'sweetalert'
import Loader from '@/components/Loader'

export default {
  name: 'SettingsWrapper',
  props: {
    dialogId: String
  },
  data() {
    return {
      settings: null,
      loading: true,
      loader: {
        autoContinue: false,
        activePlayModes: false,
        blockCopy: false,
        private: false
      },
      closeAnimation: false
    }
  },
  components: {
    Loader
  },
  methods: {
    closeWrapper(event) {
      if(event.target == this.$refs.settingsWrapper) {
        this.close();
      }
    },
    close() {
      this.closeAnimation = true;
      setTimeout(() => {
        this.$emit('close');
      }, 300);
    },
    loadDialogSettings() {
      this.loading = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadDialogSettings`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          dialogId: this.dialogId
        }
      }).then(result => {
        this.settings = result.data.dialogData;
        this.loading = false;
      }).catch(err => {
        console.log(err);
        alert.showError(err);
        this.loading = false;
      })
    },
    changeAutoContinue() {
      let newState = !this.settings.autoContinue;
      this.loader.autoContinue = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}changeAutoContinue`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          dialogId: this.dialogId,
          newState
        }
      }).then(() => {
        this.settings.autoContinue = newState;
        this.loader.autoContinue = false;
      }).catch(err => {
        console.log(err);
        alert.showError(err);
        this.loader.autoContinue = false;
      })
    },
    changeActivePlayModes(mode) {
      let newState = this.settings.activePlayModes;
      if(mode == 'play') {
        newState.play = !this.settings.activePlayModes.play;
      }
      if(mode == 'learn') {
        newState.learn = !this.settings.activePlayModes.learn;
      }
      if(mode == 'record') {
        newState.record = !this.settings.activePlayModes.record;
      }
      this.loader.activePlayModes = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}changeActivePlayModes`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          dialogId: this.dialogId,
          newState
        }
      }).then(() => {
        this.settings.activePlayModes = newState;
        this.loader.activePlayModes = false;
      }).catch(err => {
        console.log(err);
        alert.showError(err);
        this.loader.activePlayModes = false;
      })
    },
    changeCopyOption() {
      let newState = !this.settings.blockCopy;
      this.loader.blockCopy = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}changeCopyOption`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          dialogId: this.dialogId,
          newState
        }
      }).then(() => {
        this.settings.blockCopy = newState;
        this.loader.blockCopy = false;
      }).catch(err => {
        if(err.response && err.response.data.error == 'plan') {
           swal({
            title: 'Upgrade your plan to GOLD',
            text: 'You can disable copying by other users in higher subscription plans',
            icon: "warning",
            buttons: [true, "Upgrade"],
          }).then(result => {
            if(result) {
              this.$router.push('/account');
            }
          })
        } else if(err.response && err.response.data.error == 'database') {
          alert.showError('Databse Error');
        } else {
          alert.showError('Error');
        }
        this.loader.blockCopy = false;
      })
    },
    changePrivateOption() {
      let newState = !this.settings.private;
      this.loader.private = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}changePrivateOption`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          dialogId: this.dialogId,
          newState
        }
      }).then(() => {
        this.settings.private = newState;
        this.loader.private = false;
      }).catch(err => {
        console.log(err);
        alert.showError(err);
        this.loader.private = false;
      })
    },
    onSave() {
      console.log('Save Settings');
    },
  },
  computed: {
    getReversedPrivateValue() {
      return !this.settings.private;
    },
    getReversedBlockCopyValue() {
      return !this.settings.blockCopy;
    },
    getReversedAutoContinueValue() {
      return !this.settings.autoContinue;
    }
  },
  mounted() {
    this.loadDialogSettings();
  }
}
</script>

<style lang="scss" scoped>
  .settings-wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #2526295b;
    z-index: 90;
    display: flex;
    justify-content: center;
    align-items: center;

    .settings-box {
      z-index: 100;
      width: 30rem;
      height: auto;
      background-color: whitesmoke;
      border-radius: 0.2rem;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      animation: open 0.5s forwards;

      @media (max-width: 600px) {
        width: 90vw;
        height: 20rem;
        position: absolute;
        top: 10rem;
      }

      @keyframes open {
        0% {
          opacity: 0;
          transform: translateY(5rem);
        }
        100% {
          opacity: 1;
          transform: translateY(0rem);
        }
      }
    }

    .closeAnimation {
      animation: close 0.5s forwards;

      @keyframes close {
        0% {
          opacity: 1;
          transform: translateY(0rem);
        }
        100% {
          opacity: 0;
          transform: translateY(-5rem);
        }
      }
    }

    .top-row {
      width: 100%;
      height: 5rem;
      background-color: #11b6a5;
      display: flex;
      flex-direction: row;

      .title {
        flex: auto;
        height: 100%;
        display: flex;
        align-items: center;
        color: white;
        font-size: 1.5rem;
        padding-left: 2rem;
      }

      .close {
        width: 5rem;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 1.2rem;

        .icon {
          transition: 0.2s;

          &:hover {
            opacity: 0.8;
            cursor: pointer;
          }
        }
      }
    }

    .loading-row {
      width: 100%;
      height: 10rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .bottom-row {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 600px) {
        height: 15rem;
      }
      padding-top: 1.5rem;
      padding-bottom: 1rem;

      .option-row {
        width: 80%;
        height: 3rem;
        display: flex;
        margin-bottom: 0.5rem;
        @media (max-width: 600px) {
          width: 92%;
        }

        .text-box {
          flex: 2.5;
          display: flex;
          align-items: center;
          font-size: 1.05rem;

          span {
            margin-left: 1.5rem;
          }
        }
        .switch-box {
          flex: 1.8;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding-bottom: 10px;
          $toggle-background-color-on: #11b6a5;
          $toggle-background-color-off: darkgray;
          $toggle-control-color: white;
          $toggle-width: 60px;
          $toggle-height: 25px;
          $toggle-gutter: 4px;
          $toggle-radius: 50%;
          $toggle-control-speed: .15s;
          $toggle-control-ease: ease-in;
          $toggle-radius: $toggle-height / 2;
          $toggle-control-size: $toggle-height - ($toggle-gutter * 2);

          .toggle-control {
            display: block;
            position: relative;
            padding-left: $toggle-width;
            margin-bottom: 12px;
            cursor: pointer;
            font-size: 22px;
            user-select: none;
            margin-right: 1rem;

            input {
              position: absolute;
              opacity: 0;
              cursor: pointer;
              height: 0;
              width: 0;
            }

            input:checked ~ .control {
              background-color: $toggle-background-color-on;
              
              &:after {
                left: $toggle-width - $toggle-control-size - $toggle-gutter;
              }
            }

            .control {
              position: absolute;
              top: 0;
              left: 0;
              height: $toggle-height;
              width: $toggle-width;
              border-radius: $toggle-radius;
              background-color: $toggle-background-color-off;
              transition: background-color $toggle-control-speed $toggle-control-ease;

              &:after {
                content: "";
                position: absolute;
                left: $toggle-gutter;
                top: $toggle-gutter;
                width: $toggle-control-size;
                height: $toggle-control-size;
                border-radius: $toggle-radius;
                background: $toggle-control-color;
                transition: left $toggle-control-speed $toggle-control-ease;
              }
            }
          }

        }
      }

      .playmodes-row {
        width: 80%;
        height: 3rem;
        display: flex;
        margin-bottom: 0.5rem;
        @media (max-width: 600px) {
          width: 92%;
        }

        .text-box {
          flex: 2.5;
          display: flex;
          align-items: center;
          font-size: 1.05rem;

          span {
            margin-left: 1.5rem;
          }
        }
        .switch-box {
          flex: 1.8;
          display: flex;
          align-items: center;
          justify-content: space-evenly;

          .play-mode-box {
            width: 2rem;
            height: 2rem;
            background-color: darkgray;
            border-radius: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            transition: 0.3s;
            cursor: pointer;
          }

          .play-mode-active {
            background-color: #11b6a5;
          }
        }
      }
      
    }
  }

//Loading Circle
.lds-dual-ring {
  display: inline-block;
  width: 90px;
  height: 90px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid rgba(169, 169, 169, 0.692);
  border-color: rgba(169, 169, 169, 0.692) transparent rgba(169, 169, 169, 0.692) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

//Mini Loader
.lds-ring {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
}
.lds-ring div {
  margin-top: 0.5rem;
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  border: 5px solid darkgray;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: darkgray transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>